module.exports = __webpack_public_path__ + "static/img/Lenny-Douglas.a0d6f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lenny-Douglas.jpg
// module id = AhEO
// module chunks = 0